export var SCHEMA_TYPES = {
    WIX_DATA_PAGE_ITEM_IMAGES: 'wix-data-page-item-images-preset',
    WIX_DATA_PAGE_ITEM_VIDEOS: 'wix-data-page-item-videos-preset',
};
